import { Component, OnInit } from '@angular/core';
import { MockDataService } from './mock-data.service';
import { Ng2TableDefault } from '../../shared';

@Component({
  selector: 'iw-ng2-table',
  templateUrl: './ng2-table.component.html',
  styleUrls: ['./ng2-table.component.scss'],
  providers: [MockDataService]
})
export class Ng2TableComponent extends Ng2TableDefault implements OnInit {
  constructor(private mds: MockDataService) {
    super();
  }

  init() {
    super.init();
    this.columns = [
      { title: 'Name', name: `name`, filtering: { filterString: '', placeholder: 'Filter by name' } },
      {
        title: 'Username',
        name: 'username',
        sort: false,
        filtering: { filterString: '', placeholder: 'Filter by username' }
      },
      {
        title: 'Email',
        className: ['text-success', 'pointer'],
        name: 'email',
        sort: 'asc',
        filtering: { filterString: '', placeholder: 'Filter by email.' }
      },
      { title: 'Gender', name: 'gender' },
      { title: 'Phone', name: 'phone' }
    ];
  }

  ngOnInit() {
    this.mds
      .getPeople()
      .subscribe(data => {
        this.data = data;
        this.onChangeTable(this.config);
      });
  }

  onCellClick(data: any): any {
    console.log(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/ng2-table/ng2-table.component.ts